export default __webpack_public_path__ + "static/media/amparo-material-1.6a3793c4.webp";